"use client";

// Context provider que deixa o blob de `loadSiteData()` acessível pra
// qualquer Client Component descendente sem prop-drilling. O Server
// Component raiz busca os dados, passa pra `<SiteDataProvider value={...}>`
// e os componentes consomem via `useSiteData()`.

import { createContext, useContext } from "react";

const SiteDataContext = createContext(null);

export function SiteDataProvider({ value, children }) {
  return (
    <SiteDataContext.Provider value={value}>{children}</SiteDataContext.Provider>
  );
}

export function useSiteData() {
  const ctx = useContext(SiteDataContext);
  if (!ctx) {
    throw new Error("useSiteData precisa estar dentro de <SiteDataProvider>");
  }
  return ctx;
}
